import { Shape } from '@teko/ds-desktop';
import { useProductDetailState } from 'contexts';
import { t } from 'i18n';
import { Information, PolicyAndService } from './PolicyAndService';

export const Policies = () => {
  const { product, salePolicies, otherPolicies } = useProductDetailState();

  if (!product && !salePolicies?.length && !otherPolicies?.length) {
    return null;
  }

  return (
    <Shape paddingTop="s8">
      {salePolicies?.length || otherPolicies?.length ? (
        <Shape backgroundColor="white">
          {salePolicies?.length ? (
            <PolicyAndService
              title={t('Chính sách bán hàng')}
              information={salePolicies as Information[]}
              padding="s8"
            />
          ) : null}
          {otherPolicies?.length ? (
            <PolicyAndService
              title={t('Dịch vụ khác')}
              information={otherPolicies as Information[]}
              padding="s8"
            />
          ) : null}
        </Shape>
      ) : null}
    </Shape>
  );
};
